import React, { useContext } from "react";

import { CButton, CProgress } from "@coreui/react";
import { useSelector } from "react-redux";

import "./styles.scss";

import {
  arrayToCSV,
  elementToPDF,
  arrayToXLSX,
  arrayToXLS
} from "../../../utils/export";
import Charts from "../../Charts";
import LoadingStatistics from "../../LoadingStatistics";
import StatisticFiltersCompare from "../../StatisticFiltersCompare";
import { DataContext } from "../Context/DataContext";

const formatObjective = (objective, ellipsis = false) => {
  const text = objective.description || "(Sem objetivo)";

  if (!ellipsis || text.length < 50) return text;

  return `${text.substring(0, 50)}...`;
};

const AcertosPorObjetivo = ({ activity_id: activityId }) => {
  const { correctsByObjective, loading, firstLoad, fetchData } =
    useContext(DataContext);
  const token = useSelector(state => state.user.token);

  const [data, setData] = correctsByObjective;

  const route = "statistics/evaluation_corrects";

  const changeFilter = selected => {
    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      activity_id: activityId,
      type: "objective"
    };

    fetchData(params, token, route, setData);
  };

  const getCorrects = objectiveId => {
    if (!data.applications || !data.objectives) {
      return "";
    }

    const correct = data.applications.find(
      item => item.objective_id === objectiveId && item.correct
    )?.count;

    return correct || 0;
  };

  const getPercentage = objectiveId => {
    if (!data.applications || !data.objectives) {
      return 0;
    }

    const correct =
      data.applications.find(
        item => item.objective_id === objectiveId && item.correct
      )?.count || 0;
    const notCorrect =
      data.applications.find(
        item => item.objective_id === objectiveId && !item.correct
      )?.count || 0;
    const total = correct + notCorrect;

    if (total === 0) {
      return 0;
    }

    return (correct / total) * 100;
  };

  const getArray = data => {
    const header = ["objetivo", "total_acertos", "porcentagem_acertos"];

    const arr = [header];

    data.forEach(objective => {
      arr.push([
        objective.description,
        getCorrects(objective.objective_id),
        getPercentage(objective.objective_id)
      ]);
    });

    return arr;
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
          hideUser
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : (
          data &&
          data?.applications && (
            <div className="w-100">
              <div className="d-flex w-100 justify-content-end mt-3 mb-2">
                <CButton
                  id="printBtn"
                  color="link"
                  className="text-muted p-0"
                  size="sm"
                  onClick={() =>
                    arrayToXLSX(
                      getArray(data.objectives),
                      "Acertos por Objetivo.xlsx"
                    )
                  }
                >
                  <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLSX
                </CButton>
                <span className="mx-2">|</span>
                <CButton
                  id="printBtn"
                  color="link"
                  className="text-muted p-0"
                  size="sm"
                  onClick={() =>
                    arrayToXLS(
                      getArray(data.objectives),
                      "Acertos por Objetivo.xls"
                    )
                  }
                >
                  <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLS
                </CButton>
                <span className="mx-2">|</span>
                <CButton
                  id="printBtn"
                  color="link"
                  className="text-muted p-0"
                  size="sm"
                  onClick={() =>
                    arrayToCSV(
                      getArray(data.objectives),
                      "Acertos por Objetivo.csv"
                    )
                  }
                >
                  <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
                </CButton>
                <span className="mx-2">|</span>
                <CButton
                  id="printBtn"
                  color="link"
                  className="text-muted p-0"
                  size="sm"
                  onClick={() =>
                    elementToPDF("toPrint", "Acertos por Objetivo.pdf")
                  }
                >
                  <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
                </CButton>
              </div>
              <div className="w-100" id="toPrint">
                <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
                  <div className="row">
                    <div className="chart w-100">
                      <Charts
                        legendY="Objetivos"
                        legendX="Acertos %"
                        type="horizontalbar"
                        title=""
                        data={{
                          labels:
                            data.objectives?.map((objective, index) =>
                              formatObjective(objective, true)
                            ) || [],
                          datasets: [
                            {
                              data: [
                                ...(data.objectives?.map(objective =>
                                  getPercentage(objective.objective_id)
                                ) || []),
                                100
                              ],
                              backgroundColor: [
                                "rgba(255, 99, 132, 0.2)",
                                "rgba(54, 162, 235, 0.2)",
                                "rgba(255, 206, 86, 0.2)",
                                "rgba(75, 192, 192, 0.2)",
                                "rgba(153, 102, 255, 0.2)",
                                "rgba(255, 159, 64, 0.2)",
                                "rgba(255, 0, 41, 0.2)",
                                "rgba(55, 126, 184, 0.2)",
                                "rgba(102, 166, 30, 0.2)",
                                "rgba(152, 78, 163, 0.2)",
                                "rgba(0, 210, 213, 0.2)",
                                "rgba(255, 127, 0, 0.2)",
                                "rgba(254, 224, 182, 0.2)",
                                "rgba(127, 128, 205, 0.2)",
                                "rgba(179, 233, 0, 0.2)",
                                "rgba(196, 46, 96, 0.2)"
                              ],
                              borderColor: [
                                "rgba(255, 99, 132, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                                "rgba(153, 102, 255, 1)",
                                "rgba(255, 159, 64, 1)",
                                "rgba(255, 0, 41, 1)",
                                "rgba(55, 126, 184, 1)",
                                "rgba(102, 166, 30, 1)",
                                "rgba(152, 78, 163, 1)",
                                "rgba(0, 210, 213, 1)",
                                "rgba(255, 127, 0, 1)",
                                "rgba(254, 224, 182, 1)",
                                "rgba(127, 128, 205, 1)",
                                "rgba(179, 233, 0, 1)",
                                "rgba(196, 46, 96, 1)"
                              ],
                              borderWidth: 1
                            }
                          ]
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-100" style={{ marginBottom: "40px" }}>
                  <table className="table table-hover table-outline mb-0 d-none d-sm-table acertosPorQuestao w-100">
                    <thead className="thead-light">
                      <th>Objetivo</th>
                      <th>Acertos</th>
                      <th>%</th>
                    </thead>
                    <tbody>
                      {data.objectives?.map((objective, index) => (
                        <tr>
                          <td>{formatObjective(objective)}</td>
                          <td className="">
                            {getCorrects(objective.objective_id)}
                          </td>
                          <td>
                            <div className="clearfix">
                              <div className="float-left">
                                {getPercentage(objective.objective_id).toFixed(
                                  0
                                )}
                                %
                              </div>
                            </div>
                            <CProgress
                              className="progress-xs"
                              color={
                                getPercentage(objective.objective_id).toFixed(
                                  0
                                ) > 50
                                  ? "success"
                                  : getPercentage(
                                      objective.objective_id
                                    ).toFixed(0) <= 50 &&
                                    getPercentage(
                                      objective.objective_id
                                    ).toFixed(0) >= 30
                                  ? "warning"
                                  : "danger"
                              }
                              value={getPercentage(
                                objective.objective_id
                              ).toFixed(0)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default AcertosPorObjetivo;
